export const INDICATIONLIST_SEARCH = 'INDICATIONLIST_SEARCH';
export const INDICATIONLIST_PAGE = 'INDICATIONLIST_PAGE';
